import { render, staticRenderFns } from "./Hello.vue?vue&type=template&id=0f488dc4&scoped=true"
import script from "./Hello.vue?vue&type=script&lang=js"
export * from "./Hello.vue?vue&type=script&lang=js"
import style0 from "./Hello.vue?vue&type=style&index=0&id=0f488dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f488dc4",
  null
  
)

export default component.exports